module.exports = __webpack_public_path__ + "img/Delete.e6473ce0.svg";